import set from 'lodash/set';

import type { CreateLumappsChatAgentConfig } from '@lumapps/ai-ag-ui/api';
import createSlice, { PayloadAction } from '@lumapps/redux/createSlice';

import { AgentContextItem, GlobalAgentChatState } from '../types';

export const initialState: GlobalAgentChatState = {
    isChatOpen: false,
    selectedAgent: {
        initialMessages: [],
    },
    pendingAgentChange: undefined,
};

export const domain = 'agentChat';

/**
 * Redux slice for the Global Agent Chat core duck.
 * Holds the chat drawer info regarding its open state and the selected agent.
 */
const slice = createSlice({
    domain,
    initialState,
    reducers: {
        setDrawerOpen: (state: GlobalAgentChatState, action: PayloadAction<boolean>): void => {
            set(state, 'isChatOpen', action.payload);
        },
        setSelectedAgent: (state: GlobalAgentChatState, action: PayloadAction<CreateLumappsChatAgentConfig>): void => {
            set(state, 'selectedAgent', action.payload);
        },
        requestAgentChange: (
            state: GlobalAgentChatState,
            action: PayloadAction<GlobalAgentChatState['pendingAgentChange']>,
        ): void => {
            set(state, 'pendingAgentChange', action.payload);
        },
        setAgentContext: (state: GlobalAgentChatState, action: PayloadAction<AgentContextItem[] | undefined>): void => {
            set(state, 'agentContext', action.payload);
        },
        cancelAgentChange: (state: GlobalAgentChatState): void => {
            set(state, 'pendingAgentChange', undefined);
        },
        confirmAgentChange: (state: GlobalAgentChatState): void => {
            if (state.pendingAgentChange === undefined) {
                return;
            }
            set(state, 'selectedAgent', state.pendingAgentChange);
            set(state, 'pendingAgentChange', undefined);
            set(state, 'isChatOpen', true);
        },
    },
});

const { actions, reducer } = slice;

export { actions, reducer };
